var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewsvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 37,
    viewBox: "0 0 52 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7422 30.0426H32.1081C32.6333 30.0426 33.1369 29.8362 33.5083 29.4688C33.8796 29.1014 34.0882 28.6031 34.0882 28.0835V2.95903C34.0882 2.43946 33.8796 1.94117 33.5083 1.57379C33.1369 1.2064 32.6333 1 32.1081 1H2.98015C2.45498 1 1.95132 1.2064 1.57997 1.57379C1.20862 1.94117 1 2.43946 1 2.95903V28.0639C1 28.5835 1.20862 29.0818 1.57997 29.4492C1.95132 29.8166 2.45498 30.023 2.98015 30.023H5.55434",
    stroke: "#000064",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1828 30.0425H34.0884V9.93616H43.7904C43.9332 9.93615 44.0744 9.96653 44.2041 10.0252C44.3339 10.0839 44.4492 10.1695 44.542 10.2761L50.7727 17.6096C50.9201 17.7844 51.0006 18.0043 51.0001 18.2313V30.0425H46.7574",
    stroke: "#000064",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82339 36C12.2599 36 14.2352 33.9996 14.2352 31.5319C14.2352 29.0643 12.2599 27.0638 9.82339 27.0638C7.38684 27.0638 5.41162 29.0643 5.41162 31.5319C5.41162 33.9996 7.38684 36 9.82339 36Z",
    stroke: "#000064",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1764 36C44.613 36 46.5882 33.9996 46.5882 31.5319C46.5882 29.0643 44.613 27.0638 42.1764 27.0638C39.7399 27.0638 37.7646 29.0643 37.7646 31.5319C37.7646 33.9996 39.7399 36 42.1764 36Z",
    stroke: "#000064",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewsvg3);
export default __webpack_public_path__ + "static/media/overviewsvg3.8cdbda416168dce10c2813958d1fb764.svg";
export { ForwardRef as ReactComponent };